module.exports = {
	"Play": "Воспроизвести",
	"Pause": "Приостановить",
	"Current Time": "Текущее время",
	"Duration Time": "Продолжительность",
	"Remaining Time": "Оставшееся время",
	"Stream Type": "Тип потока",
	"LIVE": "ОНЛАЙН",
	"Loaded": "Загрузка",
	"Progress": "Прогресс",
	"Fullscreen": "Полноэкранный режим",
	"Non-Fullscreen": "Неполноэкранный режим",
	"Mute": "Без звука",
	"Unmute": "Со звуком",
	"Playback Rate": "Скорость воспроизведения",
	"Subtitles": "Субтитры",
	"subtitles off": "Субтитры выкл.",
	"Captions": "Подписи",
	"captions off": "Подписи выкл.",
	"Chapters": "Главы",
	"You aborted the media playback": "Вы прервали воспроизведение видео",
	"A network error caused the media download to fail part-way.": "Ошибка сети вызвала сбой во время загрузки видео.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Невозможно загрузить видео из-за сетевого или серверного сбоя либо формат не поддерживается.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Воспроизведение видео было приостановлено из-за повреждения либо в связи с тем, что видео использует функции, неподдерживаемые вашим браузером.",
	"No compatible source was found for this media.": "Совместимые источники для этого видео отсутствуют."
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-video-player/lang/ru.json
// module id = 1593
// module chunks = 2